import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

import ExternalLink from '../../common/external-link'
import GhostButton from '../../common/ghost-button'
import User from '../../../assets/icons/userbar-icons/user.svg'
import HeartWishlist from '../../../assets/icons/heart-wishlist.svg'

import { ChevronDownIcon } from '../../common/icons'

export const NavigationBarContent = styled.nav`
    display: flex;
    align-items: center;
`

export const NavigationItem = styled(ExternalLink)(
    ({ theme }) => css`
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.xLarge};
        text-decoration: none;
        user-select: none;
        padding: ${theme.spacing.xSmall};

        &:hover {
            text-decoration: underline;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.spacing.xSmall} ${theme.spacing.small};

            &:first-child {
                padding-left: 0;
            }

            &:last-child {
                padding-right: 0;
            }
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.small} 1.25rem;
        }
    `,
)

export const NavigationItemText = styled.span(
    ({ theme }) => css`
        display: none;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            display: unset;
            margin-left: ${theme.spacing.xSmall};
            max-width: 6.25rem; /* 100px. */
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    `,
)

interface WishlistIconContainerProps {
    hasCount: boolean
}

export const WishlistIconContainer = styled.div<WishlistIconContainerProps>(
    ({ hasCount, theme }) => css`
        display: flex;
        align-items: ${hasCount ? 'flex-end' : 'center'};
        position: relative;
        width: ${hasCount ? theme.layout.xSmall : '1.25rem'};
        height: ${hasCount ? theme.layout.xSmall : '1.25rem'};
    `,
)

export const WishlistIcon = styled(HeartWishlist).attrs({ width: '20px', height: '20px' })`
    min-width: 1.25rem;
    min-height: 1.25rem;
`

export const WishlistCount = styled.span(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: ${theme.layout.xxSmall};
        width: ${theme.layout.xxSmall};
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 100%;
        font-size: ${theme.typography.font.size.xxxSmall};
        background-color: ${theme.colors.tfwRed};
        border: ${theme.typography.border.width.xxThin} solid ${theme.colors.white};
        color: ${theme.colors.white};
    `,
)

export const UserButton = styled(NavigationItem).attrs({ forwardedAs: 'button', type: 'button' })`
    position: relative;
    padding: 0;
`

export const UserIcon = styled(User).attrs({ width: '24px', height: '24px' })(
    ({ theme }) => css`
        min-width: ${theme.layout.xSmall};
        min-height: ${theme.layout.xSmall};
    `,
)

export const DropdownButton = styled.div(
    ({ theme }) => css`
        padding: 0.375rem;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-left: ${theme.spacing.xxSmall};
        }
    `,
)

export const DropdownIcon = styled(ChevronDownIcon)`
    /* Remove the unnecessary height due to button height being greater than content height. */
    /* Read more: https://stackoverflow.com/a/45424887/8158281 */
    display: block;
`

export const LoginButton = styled(ExternalLink).attrs({ forwardedAs: GhostButton, padding: '0.625rem 1.875rem' })(
    ({ theme }) => css`
        font-size: ${theme.typography.font.size.small};
        margin: 0 ${theme.spacing.small};
        &:hover span {
            color: white !important;
        }
        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin: 0 0 0 1.25rem;
        }
    `,
)
